module.exports = __webpack_public_path__ + "img/IMG_1824.bf771144.jpg";